<template>
  <!-- MONEY TRANSFER -->
  <v-modal
    :name="name"
    title="Resgatar créditos"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="3"
  >
    <v-inner>
      <div v-if="!action_success">
        <v-alert>
          Para efetuar o resgate dos seus créditos você precisa enviar sua nota
          fiscal, como PESSOA JURÍDICA, no valor do resgate solicitado.
        </v-alert>
        <p>
          <b>Dados para emissão de nota fiscal</b>
        </p>
        <p>Razão Social: {{ company.name }}</p>
        <p>CNPJ: {{ company.cnpj }}</p>
        <p>Endereço: {{ company.full_address }}</p>
        <div class="form-group">
          <v-text class="form-label" tag="label" for="portfolio"
            >Nota fiscal</v-text
          >
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleFileUpload()"
            class="form-control"
          />
          <small class="form-help-text text-muted"
            >Somente arquivos em PDF.</small
          >
        </div>
        <!-- v-input type="checkbox" v-model="is_rpa">Desejo realizar o resgate via RPA</v-input -->
        <v-input type="money" v-model="value">
          Valor do resgate
          <small>(mesmo valor presente na nota fiscal)</small>
        </v-input>
        <v-button
          class="block primary"
          @click="transferMoney()"
          :disabled="disableTransfer"
          >Solicitar resgate de créditos</v-button
        >
      </div>
      <div v-else>
        <v-text class="p-3"
          >Recebemos a sua solicitação e em breve a nossa equipe financeira irá
          processá-la!</v-text
        >
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>
</template>

<script>
import vibbranteApi from '@/api/vibbrante';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'vibbrant',
    },
    data: {},
  },
  components: {},
  data() {
    return {
      action_success: false,
      value: 0.0,
      invoice_file: '',
      is_rpa: false,
      company: {},
      vibbrante: {},
      processing: false,
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    disableTransfer() {
      return (
        parseFloat(this.$store.getters.vibbrante_balances.total).toFixed(2) <
          parseFloat(this.value).toFixed(2) ||
        (this.vibbrante.is_cooperated === true &&
          this.$store.getters.vibbrante_balances.total < 1518) ||
        this.processing
      );
    },
  },
  methods: {
    fetchData() {
      vibbranteApi
        .vibbranteGetCurrentCompany()
        .then(response => {
          this.company = response.data;
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      vibbranteApi
        .getVibbranteData()
        .then(response => {
          if (response.status === 200) {
            this.vibbrante = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    handleFileUpload() {
      this.invoice_file = this.$refs.file.files[0];
    },
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');

      // OK vars
      this.feedback_ok = false;
      this.bug_ok = false;
      this.money_transfer_ok = false;
      this.action_success = false;
      this.finalized_ok = false;
    },
    onShow() {},
    transferMoney() {
      if (parseFloat(this.value).toFixed(2) > 0) {
        this.processing = true;

        // Lista de bancos válidos
        const validBanks = [
          "Banco do Brasil - 001", "Itaú - 341", "Bradesco - 237", "Caixa Econômica Federal - 104",
          "Santander - 033", "Banco Inter - 077", "Nubank", "Banco Original - 212",
          "Next (Banco Bradesco) - 077", "Neon Pagamentos", "Sicredi", "Banco Pan - 623",
          "Banco Safra - 422", "Banco BMG - 318", "Banco C6 - 336", "Banco Agibank - 121",
          "Banco BTG Pactual - 208", "Banco Sofisa Direto - 637", "Banco Daycoval - 707",
          "Banco Rendimento - 633", "Banco Votorantim - 655", "Banco Pine - 643",
          "Banco Modal - 746", "Banco Renner - 633", "Banco Digio - 790",
          "Banco do Nordeste do Brasil (BNB) - 004", "Banco de Brasília (BRB) - 070",
          "Banrisul - 041", "Banestes - 021", "Banpará - 003", "Banese - 047",
          "Banco ABC Brasil - 246", "Banco Alfa - 025", "Banco Bari - 197",
          "Banco Bonsucesso - 218", "Banco BRJ - 221", "Banco CCB Brasil - 320",
          "Banco Central do Brasil - 169", "Banco Cetelem - 739", "Banco Citibank - 477",
          "Banco CNH Industrial - 240", "Banco CSF - 131", "Banco da Amazônia (BASA) - 003",
          "Banco da China Brasil - 083", "Banco da Providência - 250",
          "Banco de Lage Landen Brasil - 654", "Banco de Tokyo-Mitsubishi UFJ Brasil - 456",
          "Banco do Estado de Sergipe (Banese) - 047", "Banco do Estado do Pará - 037",
          "Banco do Estado do Rio Grande do Sul (Banrisul) - 041", "Banco BS2 - 218",
          "Banco Cora - 403", "Stone - 197", "PicPay - 380"
        ];

        // Validação do banco
        if (!this.vibbrante.bank || !validBanks.includes(this.vibbrante.bank)) {
          this.$notify(`Para realizar o resgate de créditos, é necessário ter seus dados bancários cadastrados no perfil.
                       <br><br>
                       <a href="https://selecao.vibbra.com.br/recruitment/${this.vibbrante.id}/profile/edit"
                          target="_blank"
                          style="color: #007bff; text-decoration: underline;">
                          Clique aqui para atualizar seu perfil
                       </a>`, 'error', { mode: 'html' });
          this.processing = false;
          return;
        }

        // Validação do arquivo de nota fiscal
        if (!this.vibbrante.is_cooperated && !this.invoice_file) {
          this.$notify(
            'O arquivo de nota fiscal é obrigatório',
            'error'
          );
          this.processing = false;
          return;
        }

        if (
          parseFloat(this.$store.getters.vibbrante_balances.total).toFixed(2) <
          parseFloat(this.value).toFixed(2)
        ) {
          this.$notify(
            'Valor solicitado para resgate é maior que o disponível em carteira',
            'error'
          );
          this.onHide();
          this.show = false;
          this.processing = false;
        } else {
          const formData = new FormData();
          formData.append('vibbrante_payment[invoice_file]', this.invoice_file);
          formData.append(
            'vibbrante_payment[value]',
            parseFloat(this.value).toFixed(2)
          );
          formData.append('vibbrante_payment[is_rpa]', this.is_rpa);

          vibbranteApi
            .vibbranteTransferMoney(formData)
            .then(response => {
              if (response.status === 200) {
                this.action_success = true;
                this.processing = false;
                this.$emit('onTransferMoney');
              }
            })
            .catch(e => {
              this.processing = false;
              this.$notify(e, 'error');
            });
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/transfer-money.vue